(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-collection-carousel]').forEach(function(carousel){var track=carousel.querySelector('[data-collection-track]');carousel.querySelector('[data-collection-prev]').addEventListener('click',function(){track.scrollBy({left:-track.clientWidth*.8,behavior:'smooth'})});carousel.querySelector('[data-collection-next]').addEventListener('click',function(){track.scrollBy({left:track.clientWidth*.8,behavior:'smooth'})})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-carousel]').forEach(function(carousel){var track=carousel.querySelector('[data-carousel-track]');carousel.querySelector('[data-carousel-prev]').addEventListener('click',function(){track.scrollBy({left:-track.clientWidth*.8,behavior:'smooth'})});carousel.querySelector('[data-carousel-next]').addEventListener('click',function(){track.scrollBy({left:track.clientWidth*.8,behavior:'smooth'})})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('product-recommendations').forEach(el=>{fetch(el.dataset.url).then(r=>r.text()).then(t=>{const d=new DOMParser().parseFromString(t,'text/html').querySelector('product-recommendations');if(d)el.innerHTML=d.innerHTML})})
  } catch(e) { console.error(e); }
})();
})();
